import { connectedStore } from '../../store';
import { USED_ACTION_CREATOR } from '../constants/symbols';
import bulkViewActions from '../actions/bulk-view-actions';

const bulkViewOperations = (operations, options) => {
  const store = connectedStore.get();

  const actions = operations.reduce((result, operation) => {
    const [operationFn, params = []] = operation;
    const usedActionCreator = operationFn[USED_ACTION_CREATOR];

    if (typeof usedActionCreator === 'function') {
      result.push(usedActionCreator(...params));
    }

    return result;
  }, []);

  if (actions.length) {
    store.dispatch(bulkViewActions(actions, options));
  }
};

export default bulkViewOperations;
